import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchUniUniShipments } from '../api/uniuniShipments.api';

export const useUniUniShipments = (filters: any) =>
  useQuery({
    queryKey: ['uniuniShipments', filters],
    queryFn: () => fetchUniUniShipments(filters),
    placeholderData: keepPreviousData,
  });
